const surveyStyle = {
  container: {
    position: 'absolute',
    top: 60,
    left: 250,
    width: 1500,
    height: 900,
    background: 'linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 30%, rgba(227,227,227,1) 100%)',
    zIndex: 5,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  loaderContainer: {
    position: 'absolute',
    top: 0,
    left: 400,
    width: 1100,
    height: 900,
    // background: 'linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 30%, rgba(227,227,227,1) 100%)',
    zIndex: 5,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  text: {
    fontFamily: "Gotham-Med"
  },
  questionContainer: {
    width: "700px",
    position: "absolute",
    top: "50px",
    left: "500px"
  },
  title: {
    color: '#0093D0',
    fontFamily: "Gotham-Book",
    position: "absolute",
    top: '50px',
    width: '700px',
    // left: '150px'
    fontSize: '56px',
    fontWeight: 'bold'
  },
  subtitle: {
    color: '#565656',
    fontFamily: "Gotham-Book",
    position: "absolute",
    top: "160px",
    fontWeight: 'bold'
    // left: "200px"
  },
  answersContainer: {
    position: "absolute",
    top: '350px',
    left: '507px',
    width: '1000px'
  },
  colorButton: {
    width: '60px !important',
    height: '60px !important'
  },
  trigger: {
    width: '960px',
    height: '1080px',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
    position: "absolute",
    bottom: '90px',
    left: '80px',
    backgroundColor: "rgba(0,0,0,0.01)"
  },
  feedbackContainer: {
    position: "absolute",
    top: "60px",
    left: "250px",
    width: "1500px",
    height: "900px",
    background: "linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 30%, rgb(227, 227, 227) 100%)",
    zIndex: "10",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#3184c3",
    boxShadow: "unset"
  },
  feedbackMessage:{
    fontFamily: 'Gotham-Med',
    width: '800px',
    height: '100px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    fontSize: "50px"
  },
  footerContainer: {
    position: "absolute",
    display: "flex",
    bottom: "-50px",
    justifyContent: "center",
    alignItems: "center",
    width: "960px",
    right: "50px",
    height: "60px"
  },
  backSuccessArrow: {
    position: "absolute",
    top: "725px",
    left: "1260px"
  }
}

export default surveyStyle;